export const PAIDY_DATA_TITLE = "PAIDY_DATA_TITLE";

export const PAIDY_PROCESSING_INFO = "PAIDY_PROCESSING_INFO";
export const PAIDY_CONFIRM_CHARGE = "PAIDY_CONFIRM_CHARGE";

export const PAIDY_FORM_DATA_DOB = "PAIDY_FORM_DATA_DOB";
